<template>
  <v-snackbar v-model="visible" :timeout="timeout" :color="color" top>
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        class="black--text"
        color="white"
        small
        v-bind="attrs"
        @click="handleCloseSnackbar"
        :loading="isLoading"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'GlobalSnackbar',
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState('snackbar', ['text', 'color', 'timeout', 'onClose']),
    visible: {
      get() {
        return this.$store.state.snackbar.visible
      },
      set(val) {
        if (!val) this.hideSnackbar()
      },
    },
  },
  methods: {
    ...mapMutations('snackbar', ['hideSnackbar']),
    async handleCloseSnackbar() {
      try {
        this.isLoading = true
        if (this.onClose) await this.onClose()
        this.hideSnackbar()
      } catch (e) {
        console.error(e)
        throw new Error(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped></style>
